/* eslint-disable */
import React from 'react';

export function Tree({ className }: { className: string }) {
  return <></>;
}
